// CTTable Component
const CTTable = () => (
        <div className="overflow-x-auto">
                <table className="table table-bordered w-full">
                        <thead>
                                <tr>
                                        <th></th>
                                        <th colSpan="2">Monday</th>
                                        <th colSpan="2">Tuesday</th>
                                        <th colSpan="2">Wednesday</th>
                                        <th colSpan="2">Thursday</th>
                                        <th colSpan="2">Friday</th>
                                </tr>
                        </thead>
                        <tbody>
                                {/* Clinician Sections */}
                                {[1, 2, 3].map(num => (
                                        <CTSection
                                                key={num}
                                                number={num}
                                                data={[
                                                        {
                                                                doctor: 'Nick',
                                                                time: '1:00-1:15pm'
                                                        },
                                                        // Add more days
                                                ]}
                                        />
                                ))}
                        </tbody>
                </table>
        </div>
);

// CTSection Component
const CTSection = ({ number, data }) => (
        <>
                <tr>
                        <th rowSpan="3">{number}</th>
                </tr>
                <tr className="border-t-2 border-gray-300">
                        <th>Doctor</th>
                        <td>{data[0]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[1]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[2]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[3]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[4]?.doctor}</td>
                </tr>
                <tr>
                        <th>Time</th>
                        <td>{data[0]?.time}</td>
                        <th>Time</th>
                        <td>{data[1]?.time}</td>
                        <th>Time</th>
                        <td>{data[2]?.time}</td>
                        <th>Time</th>
                        <td>{data[3]?.time}</td>
                        <th>Time</th>
                        <td>{data[4]?.time}</td>
                </tr>
        </>
);

export default CTTable;
